(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-plus-html"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      document.querySelectorAll('[data-gt-plus-root]').forEach(root => {
        if (root.dataset.gtPlusReady === 'true') return;
        root.dataset.gtPlusReady = 'true';

        const getDialog = () =>
          document.getElementById(root.dataset.gtPlusVideoId);

        root.querySelectorAll('[data-video], [data-gt-plus-video]')
          .forEach(button => {
            button.hidden = !getDialog();

            button.addEventListener('click', event => {
              const dialog = getDialog();
              if (!dialog) return;

              event.preventDefault();

              if (!dialog.open) {
                dialog.showModal();
              }
            });
          });

        root.querySelectorAll('a[href^="#"]').forEach(link => {
          link.addEventListener('click', event => {
            if (
              event.defaultPrevented ||
              event.button !== 0 ||
              event.metaKey ||
              event.ctrlKey ||
              event.shiftKey ||
              event.altKey
            ) return;

            const href = link.getAttribute('href');
            if (!href || href === '#') return;

            const target = document.getElementById(href.slice(1));
            if (!target) return;

            event.preventDefault();

            target.scrollIntoView({
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
                ? 'auto'
                : 'smooth',
              block: 'start'
            });
          });
        });
      });

      document.querySelectorAll('.gt-plus-video-dialog').forEach(dialog => {
        if (dialog.dataset.gtPlusReady === 'true') return;
        dialog.dataset.gtPlusReady = 'true';

        dialog.querySelector('[data-gt-plus-close]')
          ?.addEventListener('click', () => dialog.close());

        dialog.addEventListener('close', () => {
          dialog.querySelectorAll('video').forEach(video => video.pause());
        });

        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;

          const bounds = dialog.getBoundingClientRect();

          if (
            event.clientX < bounds.left ||
            event.clientX > bounds.right ||
            event.clientY < bounds.top ||
            event.clientY > bounds.bottom
          ) {
            dialog.close();
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-skills-header"]) return;
  try {
    
if (!customElements.get('gts-sol-nav')) { customElements.define('gts-sol-nav', class extends HTMLElement { connectedCallback(){ if(this.ready)return;this.ready=true; const details=[...this.querySelectorAll('details')]; this.addEventListener('keydown',e=>{if(e.key==='Escape')details.forEach(d=>d.open=false)}); document.addEventListener('click',this._outside=(e)=>{details.forEach(d=>{if(!d.contains(e.target))d.open=false})}); } disconnectedCallback(){document.removeEventListener('click',this._outside)} }); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-skills-inter-header"]) return;
  try {
    
if (!customElements.get('gts-inter-navigation')) {
  customElements.define('gts-inter-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.gtsReady) return;
      this.gtsReady = true;
      const menu = this.querySelector('details');
      if (!menu) return;
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary')?.focus(); }
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
      this.gtsOutside = event => { if (!this.contains(event.target)) menu.open = false; };
      document.addEventListener('click', this.gtsOutside);
    }
    disconnectedCallback() { document.removeEventListener('click', this.gtsOutside); this.gtsReady = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-skills-inter"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('.gts-inter-landing');
  roots.forEach(root => {
    if (root.dataset.gtsTabsReady === 'true') return;
    root.dataset.gtsTabsReady = 'true';
    const tabs = [...root.querySelectorAll('[data-tab]')];
    const panels = [...root.querySelectorAll('[data-panel]')];
    tabs.forEach(tab => tab.addEventListener('click', () => {
      tabs.forEach(t => t.setAttribute('aria-selected', 'false'));
      tab.setAttribute('aria-selected', 'true');
      panels.forEach(panel => { panel.hidden = panel.dataset.panel !== tab.dataset.tab; });
    }));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-skills-tutoriales"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gts-tutorial-library')) {
  customElements.define('gts-tutorial-library', class extends HTMLElement {
    connectedCallback(){
      if(this.ready)return; this.ready=true;
      this.search=this.querySelector('[data-search]');
      this.cards=[...this.querySelectorAll('[data-card]')];
      this.filters=[...this.querySelectorAll('[data-filter]')];
      this.empty=this.querySelector('[data-empty]');
      this.active='todos';
      this.search?.addEventListener('input',()=>this.apply());
      this.querySelector('[data-clear]')?.addEventListener('click',()=>{this.search.value='';this.apply();this.search.focus()});
      this.querySelector('[data-show-all]')?.addEventListener('click',()=>{this.search.value='';this.active='todos';this.sync();this.apply()});
      this.filters.forEach(btn=>btn.addEventListener('click',()=>{this.active=btn.dataset.filter;this.sync();this.apply()}));
      this.apply();
    }
    sync(){this.filters.forEach(btn=>btn.classList.toggle('is-active',btn.dataset.filter===this.active))}
    apply(){
      const q=(this.search?.value||'').trim().toLowerCase(); let visible=0;
      this.cards.forEach(card=>{
        const category=card.dataset.category; const hay=(card.dataset.searchtext||'').toLowerCase();
        const show=(this.active==='todos'||category===this.active)&&(!q||hay.includes(q));
        card.hidden=!show; if(show)visible++;
      });
      if(this.empty)this.empty.hidden=visible!==0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
